<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="review-order-start order-status-main">
      <div class="review-container review-main text-capitalize position-relative">
        <div class="row">
          <div class="text-center col-md-12 p-0 my-2 odr-loadr" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <div v-if="ordersDetail.length > 0" class="odr-sts">
            <div class="col-md-12 px-2" v-for="(orders, index) in ordersDetail" :key="index">
              <p class="dsply-msg" v-if="
                delayMsg &&
                orders.order_status != 'Delivered' &&
                orders.delivery_pickup_types != 'Pickup'
              ">
                {{ $auth.setting.delay_message }}
              </p>
              <div class="resturant-details d-flex align-items-start plr15">
                <div class="resturant-details-box px-0">
                  <div class="img-cls">
                    <img :src="orders.restaurant_image
                      ? orders.restaurant_image
                      : imageErrorHandle
                      " class="mr-3" @error="imageErrorHandle" />
                  </div>
                  <div class="status-con">
                    <h6>{{ orders.restaurant_name }}</h6>
                    <p class="orderid">
                      {{ $t("Order") }} #{{ orders.order_id }}
                    </p>

                    <p v-if="orders.future_delivery_date != '0000-00-00 00:00:00'">
                      {{  moment(orders.future_delivery_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM D, YYYY [at] hh:mm A') }}
                    </p>

                    <p v-else-if="displayMinute > 0 && (orders.order_status == 'Cancelled' || orders.order_status == 'Delivered')">
                      Track order #{{ orders.order_id }}
                    </p>
                    <!-- <p v-else-if="displayMinute > 0 && orders.order_status == 'Delivered'">
                      Track order #{{ orders.order_id }}
                    </p> -->
                    <p v-else-if="displayMinute > 0">
                      Delivery in {{ displayMinute }} Minutes
                    </p>
                    <a class="status-call-btn" :href="'tel:' + orders.support_contact_number"><i
                        class="fas fa-phone-alt mr-2"></i>{{ $t("Call") }}</a>
                  </div>
                </div>
                <div class="rdctr-dedetail">
                  <router-link :to="{
                    name: 'order-details',
                    params: { order_id: base64_encode(orders.order_id) },
                  }">
                    <span>
                      <svg fill="#000000" height="15px" width="15px" version="1.1" id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 330 330" xml:space="preserve">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path id="XMLID_222_"
                            d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001 c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213 C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606 C255,161.018,253.42,157.202,250.606,154.389z">
                          </path>
                        </g>
                      </svg> </span></router-link>
                </div>
              </div>
              <div class="order-status-timeline">
                <div class="timeline-block timeline-block-right">
                  <div class="marker" :class="{
                    active: [
                      'Placed',
                      'ReadyToServe',
                      'InKitchen',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <i class="fa fa-check" :class="{
                      active: [
                        'Placed',
                        'ReadyToServe',
                        'InKitchen',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: [
                      'Placed',
                      'ReadyToServe',
                      'InKitchen',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <h3>{{ $t("Order Placed") }}</h3>
                    <span v-if="
                      [
                        'Placed',
                        'ReadyToServe',
                        'InKitchen',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status)
                    ">{{
                      $t(
                        "We have Received your order Request.Waiting for name to confirm the order",
                        { msg: orders.restaurant_name }
                      )
                    }}.</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                </div>

                <div class="timeline-block timeline-block-left">
                  <div class="marker" :class="{
                    active: [
                      'ReadyToServe',
                      'InKitchen',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <i class="fa fa-check" :class="{
                      active: [
                        'ReadyToServe',
                        'InKitchen',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: [
                      'ReadyToServe',
                      'InKitchen',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <h3>{{ $t("Order Confirmed") }}</h3>
                    <span v-if="
                      [
                        'ReadyToServe',
                        'InKitchen',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status)
                    ">{{
                      $t(
                        "restaurant_name is preparing your order. As soon as it is ready, we will notify you",
                        { msg: orders.restaurant_name }
                      )
                    }}</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                </div>

                <div class="timeline-block timeline-block-left">
                  <div class="marker" :class="{
                    active: [
                      'ReadyToServe',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <i class="fa fa-check" :class="{
                      active: [
                        'ReadyToServe',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: [
                      'ReadyToServe',
                      'OnTheWay',
                      'Arrived',
                      'Delivered',
                    ].includes(orders.order_status),
                  }">
                    <h3>{{ $t("Food Ready") }}</h3>
                    <span v-if="
                      [
                        'ReadyToServe',
                        'OnTheWay',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status)
                    ">Your food is ready. Waiting for
                      {{ $auth.setting && $auth.setting.driver_name }} to
                      pickup.</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                </div>
                <div class="timeline-block timeline-block-left" v-if="orders.delivery_pickup_types == 'Delivery'">
                  <div class="marker" :class="{
                    active: ['OnTheWay', 'Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <i class="fa fa-check" :class="{
                      active: ['OnTheWay', 'Arrived', 'Delivered'].includes(
                        orders.order_status
                      ),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content d-flex justify-content-between align-items-start" :class="{
                    active: ['OnTheWay', 'Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <div class="ontheway">
                      <h3>{{ $t("On The Way") }}</h3>
                      <span v-if="
                        ['OnTheWay', 'Arrived', 'Delivered'].includes(
                          orders.order_status
                        )
                      ">Our {{ $auth.setting && $auth.setting.driver_name }} is
                        out for delivery. You can track exact status on track
                        screen</span>
                      <span v-else>{{ $t("Waiting") }}</span>
                    </div>
                    <router-link v-if="
                      ['OnTheWay'].includes(orders.order_status) 
                    " class="status-call-btn d-flex" :to="{
                      name: 'trackorder',
                      params: { order_id: base64_encode(orders.order_id) },
                    }">{{ $t("Live Track") }}</router-link>
                    <a :href="orders.tracking_url" target="_blank" v-if="
                      ['OnTheWay'].includes(orders.order_status) &&
                      orders.dunzo_driver == '1'
                    " class="status-call-btn d-flex">{{ $t("Live Track") }}</a>
                    <div class="tack-call" v-if="['OnTheWay'].includes(orders.order_status)">
                      <a class="status-call-btn" :href="'tel:' + orders.contactno"><i
                          class="fas fa-phone-alt mr-2"></i>{{ $t("Call") }}</a>
                    </div>
                  </div>
                </div>
                <div class="timeline-block timeline-block-left" v-else>
                  <div class="marker" :class="{
                    active: ['ReadyToServe', 'Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <i class="fa fa-check" :class="{
                      active: [
                        'ReadyToServe',
                        'Arrived',
                        'Delivered',
                      ].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content d-flex justify-content-between align-items-start" :class="{
                    active: ['OnTheWay', 'Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <div class="ontheway">
                      <h3>{{ $t("Order Ready To Pickup") }}</h3>
                      <span v-if="
                        ['ReadyToServe', 'Arrived', 'Delivered'].includes(
                          orders.order_status
                        )
                      ">{{
                        $t(
                          "Your order is ready to pickup. Collect order as soon as possible from name",
                          { msg: orders.restaurant_name }
                        )
                      }}
                        .</span>
                      <span v-else>{{ $t("Waiting") }}</span>
                    </div>
                  </div>
                </div>
                <div class="timeline-block timeline-block-left" v-if="orders.delivery_pickup_types == 'Delivery'">
                  <div class="marker" :class="{
                    active: ['Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <i class="fa fa-check" :class="{
                      active: ['Arrived', 'Delivered'].includes(
                        orders.order_status
                      ),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: ['Arrived', 'Delivered'].includes(
                      orders.order_status
                    ),
                  }">
                    <h3>{{ $t("Arrived") }}</h3>
                    <span v-if="
                      ['Arrived', 'Delivered'].includes(orders.order_status)
                    ">{{
                      $t("Your order has just arrived at your doorstep")
                    }}</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                  <router-link v-if="
                    ['Arrived'].includes(orders.order_status) &&
                    orders.dunzo_driver == '0'
                  " class="status-call-btn d-flex" :to="{
                    name: 'trackorder',
                    params: { order_id: base64_encode(orders.order_id) },
                  }">{{ $t("Live Track") }}</router-link>
                  <a :href="orders.tracking_url" target="_blank" v-if="
                    ['Arrived'].includes(orders.order_status) &&
                    orders.dunzo_driver == '1'
                  " class="status-call-btn d-flex">{{ $t("Live Track") }}</a>
                  <div class="tack-call" v-if="['Arrived'].includes(orders.order_status)">
                    <a class="status-call-btn" :href="'tel:' + orders.contactno"><i class="fas fa-phone-alt mr-2"></i>{{
                      $t("Call") }}</a>
                  </div>
                </div>
                <div class="timeline-block timeline-block-right" v-if="orders.delivery_pickup_types == 'Delivery'">
                  <div class="marker" :class="{
                    active: ['Delivered'].includes(orders.order_status),
                  }">
                    <i class="fa fa-check" :class="{
                      active: ['Delivered'].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: ['Delivered'].includes(orders.order_status),
                  }">
                    <h3>{{ $t("Delivered") }}</h3>
                    <span v-if="['Delivered'].includes(orders.order_status)">{{
                      $t(
                        "Your Order has been Delivered. Please don't forget to rate our service"
                      )
                    }}.</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                </div>
                <div class="timeline-block timeline-block-right" v-else>
                  <div class="marker" :class="{
                    active: ['Delivered'].includes(orders.order_status),
                  }">
                    <i class="fa fa-check" :class="{
                      active: ['Delivered'].includes(orders.order_status),
                    }" aria-hidden="true"></i>
                  </div>
                  <div class="timeline-content" :class="{
                    active: ['Delivered'].includes(orders.order_status),
                  }">
                    <h3>{{ $t("Order Collected") }}</h3>
                    <span v-if="['Delivered'].includes(orders.order_status)">{{
                      $t(
                        "Your Order has been Delivered. Please don't forget to rate our service"
                      )
                    }}.</span>
                    <span v-else>{{ $t("Waiting") }}</span>
                  </div>
                </div>
              </div>
              <div v-if="orders.order_status == 'Delivered'">
                <div class="delivery-address plr15 rate-btn" v-if="ratingExiting == 'false'">
                  <div class="full-btn">
                    <router-link :to="{
                      name: 'rating',
                      params: { order_id: base64_encode(orders.order_id) },
                    }">{{ $t("Rate Us") }}</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-offers" v-if="ordersDetail.length == 0 && !loading">
          <p class="text-center">{{ $t("No Order Found") }}</p>
        </div>
        <div class="col-12 p-0 mb-4" v-if="ordersDetail && ordersDetail[0]">
          <div class="preparing-order-wrapper">
            <h6>{{ ordersDetail[0].restaurant_name }}</h6>
            <div class="preparing-order-summary">
              <ul >
                <li style="color: var(--theme-font-secondary)">{{ `#${ordersDetail[0].order_id}` }}</li>
                <li><router-link :to="{
                    name: 'order-details',
                    params: { order_id: base64_encode(ordersDetail[0].order_id) },
                  }">{{ $t('Order summary') }}</router-link></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 mb-4">
          <div class="rateus-our-appstore-wrapper">
            <div class="rateus-our-img-content">
              <div class="rateus-our-img-part">
                <img src="../assets/images/like-our-service.svg" alt="like-our-service" />
              </div>
              <div class="rateus-content-part">
                <h6>Do you like our service?</h6>
                <span>Do rate us App store. if you are enjoying our service.</span>
              </div>
            </div>
            <p class="d-flex justify-content-center"><a href="https://play.google.com/store/apps/details?id=com.chowman.ordering&hl=en" target="_blank">Rate us on app store</a></p>
          </div>
        </div>
        <div class="col-12 p-0 mb-4" v-if="adsArray.length > 0">
          <VueSlickCarousel class="free-delivery" v-bind="newsettings">
            <div v-for="(ads,i) in adsArray" :key="i">
              <!-- slider iteme start -->
              <div class="slide-item">
                <div class="emergency-sec-wrapper">
                <div class="emergency-sec">
                  <div class="emergency-wrapper">
                    <div class="profile-icon">
                      <img :src="ads.icon_image" @error="imageErrorHandle" alt="like-our-service" />
                    </div>
                    <div class="profile-content">
                      <h6>{{ ads.title }}</h6>
                      <p>
                        {{ ads.description }}
                      </p>
                    </div>
                  </div>
                  <iframe class="fast-delivery-image" v-if="ads.video_id && ads.video_id != 'null'"
                      :src="`https://www.youtube.com/embed/${ads.video_id}`">
                  </iframe>
                  <div class="fast-delivery-image" v-else>
                    <img :src="ads.image" alt="like-our-service" @error="imageErrorHandle" />
                  </div>
                </div>
              </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="col-12 p-0 mb-4" v-if="this.promotional_text && this.promotional_text.id">
          <div class="carousel-container">
            <div class="slide-item">
              <div class="free-delivery-message">
                <div class="free-delivery-description">
                  <img
                    src="https://chowmanstorage.s3.ap-south-1.amazonaws.com/media/foodapp/original/food_logo_17193154248428.png"
                    alt="Logo" />
                  <h5>{{ promotional_text.title }}</h5>
                  <p>{{ promotional_text.description }}</p>
                </div>
                <div class="free-delivery-img">
                  <img :src="promotional_text.image" @error="imageErrorHandle" alt="logo-o" />
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div class="col-12 p-0 mb-4">
          <div class="need-your-order-parent">
            <div class="preparing-order-wrapper">
              <div>
                <div class="rateus-our-img-content">
                  <div class="rateus-our-img-part">
                    <img src="../assets/images/call-inject.svg" alt="like-our-service" />
                  </div>
                  <div class="rateus-content-part">
                    <h6 class="mb-2">Need help with your order</h6>
                    <span>Chowman support is always available</span>
                  </div>
                </div>
              </div>
              <div class="support-order-summary">
                <ul>
                  <li><router-link :to="{name:'support-chat'}">Chat with us</router-link></li>
                  <li>|</li>
                  <li v-if="ordersDetail && ordersDetail[0]"><a :href="'tel:' + ordersDetail[0].support_contact_number">Support &nbsp;<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.5839 11.9659L12.0551 11.434H12.0551L12.5839 11.9659ZM12.9635 11.5885L13.4923 12.1203L12.9635 11.5885ZM14.9774 11.3245L14.6191 11.9834L14.9774 11.3245ZM16.5694 12.19L16.2112 12.8489L16.5694 12.19ZM17.0181 14.9025L17.5469 15.4343L17.0181 14.9025ZM15.8343 16.0795L15.3055 15.5477L15.8343 16.0795ZM14.7302 16.6376L14.7998 17.3844H14.7998L14.7302 16.6376ZM6.5128 13.1055L7.04162 12.5736L6.5128 13.1055ZM2.50241 5.62134L1.75361 5.66389L1.75361 5.66389L2.50241 5.62134ZM7.89793 6.83115L8.42675 7.36299L7.89793 6.83115ZM8.02853 4.61957L8.62893 4.1701V4.1701L8.02853 4.61957ZM6.97771 3.2159L6.37732 3.66537L6.37732 3.66537L6.97771 3.2159ZM4.38454 2.97902L4.91336 3.51086V3.51086L4.38454 2.97902ZM3.07654 4.2796L2.54772 3.74776H2.54772L3.07654 4.2796ZM9.21927 10.4144L9.74809 9.88253L9.21927 10.4144ZM13.1127 12.4977L13.4923 12.1203L12.4347 11.0566L12.0551 11.434L13.1127 12.4977ZM14.6191 11.9834L16.2112 12.8489L16.9276 11.5311L15.3356 10.6656L14.6191 11.9834ZM16.4892 14.3706L15.3055 15.5477L16.3631 16.6114L17.5469 15.4343L16.4892 14.3706ZM14.6606 15.8909C13.4823 16.0007 10.3953 15.9082 7.04162 12.5736L5.98398 13.6373C9.70829 17.3405 13.2624 17.5277 14.7998 17.3844L14.6606 15.8909ZM7.04162 12.5736C3.83768 9.38789 3.316 6.71901 3.2512 5.57878L1.75361 5.66389C1.83906 7.16735 2.51351 10.1865 5.98398 13.6373L7.04162 12.5736ZM8.18774 7.60065L8.42675 7.36299L7.36911 6.29932L7.1301 6.53697L8.18774 7.60065ZM8.62893 4.1701L7.57811 2.76643L6.37732 3.66537L7.42814 5.06904L8.62893 4.1701ZM3.85572 2.44719L2.54772 3.74776L3.60536 4.81144L4.91336 3.51086L3.85572 2.44719ZM7.65892 7.06881C7.1301 6.53697 7.12939 6.53768 7.12867 6.5384C7.12843 6.53864 7.12771 6.53936 7.12722 6.53985C7.12625 6.54083 7.12526 6.54183 7.12425 6.54285C7.12225 6.54489 7.12018 6.54701 7.11806 6.54921C7.11382 6.55361 7.10936 6.55834 7.1047 6.5634C7.09539 6.57351 7.08527 6.58496 7.07453 6.59777C7.05306 6.62339 7.02907 6.65454 7.00406 6.69145C6.9539 6.76548 6.90004 6.86219 6.8546 6.98279C6.76169 7.22938 6.71411 7.54895 6.77452 7.93837C6.8923 8.69759 7.41022 9.67324 8.69045 10.9462L9.74809 9.88253C8.56581 8.70697 8.30355 8.00985 8.25679 7.70841C8.2455 7.63563 8.24664 7.58597 8.2496 7.5565C8.25254 7.52713 8.25774 7.51308 8.25827 7.51166C8.25893 7.50992 8.25631 7.51741 8.24587 7.53282C8.24072 7.54042 8.2337 7.5499 8.22424 7.56119C8.21951 7.56683 8.21416 7.57294 8.20811 7.57952C8.20508 7.5828 8.20188 7.58621 8.19849 7.58973C8.19679 7.59149 8.19505 7.59328 8.19326 7.5951C8.19236 7.59601 8.19146 7.59693 8.19054 7.59785C8.19008 7.59831 8.18938 7.59901 8.18915 7.59924C8.18844 7.59994 8.18774 7.60065 7.65892 7.06881ZM8.69045 10.9462C9.9712 12.2197 10.9512 12.733 11.7113 12.8496C12.1008 12.9094 12.42 12.8623 12.6663 12.7706C12.7868 12.7257 12.8836 12.6724 12.9578 12.6227C12.9947 12.598 13.026 12.5742 13.0517 12.5529C13.0645 12.5422 13.076 12.5322 13.0862 12.5229C13.0913 12.5183 13.096 12.5139 13.1004 12.5097C13.1027 12.5076 13.1048 12.5055 13.1068 12.5035C13.1079 12.5025 13.1089 12.5015 13.1099 12.5006C13.1103 12.5001 13.1111 12.4994 13.1113 12.4991C13.112 12.4984 13.1127 12.4977 12.5839 11.9659C12.0551 11.434 12.0558 11.4333 12.0565 11.4326C12.0568 11.4324 12.0575 11.4317 12.0579 11.4312C12.0589 11.4303 12.0598 11.4294 12.0607 11.4285C12.0625 11.4267 12.0643 11.425 12.0661 11.4233C12.0696 11.42 12.073 11.4168 12.0763 11.4138C12.0829 11.4078 12.0891 11.4025 12.0947 11.3978C12.106 11.3884 12.1154 11.3815 12.123 11.3765C12.1382 11.3663 12.1452 11.364 12.1427 11.3649C12.1405 11.3658 12.1254 11.3712 12.0947 11.3742C12.064 11.3773 12.0129 11.3784 11.9387 11.367C11.6322 11.32 10.9298 11.0576 9.74809 9.88253L8.69045 10.9462ZM7.57811 2.76643C6.68596 1.57471 4.9273 1.38169 3.85572 2.44719L4.91336 3.51086C5.29929 3.12712 5.99785 3.15849 6.37732 3.66537L7.57811 2.76643ZM3.2512 5.57878C3.2374 5.336 3.34771 5.06762 3.60536 4.81144L2.54772 3.74776C2.08267 4.21017 1.70869 4.87332 1.75361 5.66389L3.2512 5.57878ZM15.3055 15.5477C15.0908 15.7611 14.8709 15.8713 14.6606 15.8909L14.7998 17.3844C15.4485 17.3239 15.9757 16.9965 16.3631 16.6114L15.3055 15.5477ZM8.42675 7.36299C9.2935 6.50116 9.35558 5.14074 8.62893 4.1701L7.42814 5.06904C7.72889 5.47078 7.67996 5.99024 7.36911 6.29932L8.42675 7.36299ZM16.2112 12.8489C16.8246 13.1823 16.9069 13.9554 16.4892 14.3706L17.5469 15.4343C18.7274 14.2605 18.3591 12.3092 16.9276 11.5311L16.2112 12.8489ZM13.4923 12.1203C13.7714 11.8428 14.2259 11.7696 14.6191 11.9834L15.3356 10.6656C14.3862 10.1495 13.2049 10.2907 12.4346 11.0566L13.4923 12.1203Z"
                        fill="#EF2121" />
                    </svg>
                  </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { mapActions } from "vuex";
import Footer from "../components/Footer.vue";
import moment from "moment";
import { imageErrorHandle } from "../helper/helper.js";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "FreeDeliveryCarousel",
  components: {
    NavBar,
    Footer,
    VueSlickCarousel,
  },
  data() {
    return {
      moment:moment,
      ordersDetail: [],
      ratingExiting: "",
      loading: true,
      displayMinute: "",
      delayMsg: "",
      imageErrorHandle: imageErrorHandle,
      newsettings: {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
      },
      restaurant_id:'',
      promotional_text:{},
      adsArray:[],
    };
  },
  mounted() {
    if (this.$auth.user) {
      this.orderDetails();
      this.checkRating();
    } else {
      this.$router.push({ name: "sign-in" });
    }
  },

  methods: {
    ...mapActions("order", ["viewOrderDetail", "checkOrderRating"]),
    ...mapActions("restaurant", ["getPromotion"]),

    orderDetails() {
      if (this.isBase64(this.$route.params.order_id)) {
        this.viewOrderDetail({
          vendor_id: this.$auth.getVendorId(),
          order_id: this.base64_decode(this.$route.params.order_id),
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.ordersDetail = data.Result;
            this.restaurant_id = this.ordersDetail[0].restaurant_id || '';
            this.getPromotionBanner();
            let crrntday = moment().format("YYYY-MM-DD HH:mm:ss");
            if (data.Result[0].eta_delivery_times > 0) {
              const minutes = moment
                .utc(data.Result[0].eta_delivery_times * 1000)
                .format("m");
              this.displayMinute = minutes;
            } else {
              const minutes = moment
                .utc(data.Result[0].delivery_times * 1000)
                .format("m");
              this.displayMinute = minutes;
            }
            if (moment(data.Result[0].eta).diff(crrntday, "minutes") > 0) {
              this.delayMsg = false;
            } else {
              this.delayMsg = true;
            }

            if (data.Result && data.Result[0].order_status == "Cancelled") {
              this.$router.push({
                name: "order-details",
                params: {
                  order_id: this.base64_encode(data.Result[0].order_id),
                },
              });
            }
            this.loading = false;
          }
        });
      } else {
        this.ordersDetail = [];
        this.loading = false;
      }
    },

    getPromotionBanner(){
        this.getPromotion({
          restaurant_id:this.restaurant_id
        }).then((response)=>{
          if(response.code == 200){
            this.promotional_text = response.Result.promotional_text || {};
            this.adsArray = response.Result.ads || []
          }
        }).catch((error)=>{
          console.log(error)
        });
    },

    checkRating() {
      this.checkOrderRating({
        vendor_id: this.$auth.getVendorId(),
        order_id: this.base64_decode(this.$route.params.order_id),
        is_langauge: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
      }).then((data) => {
        if (data.code == 200) {
          this.ratingExiting = data.Result.status;
        }
      });
    },

    isBase64(str) {
      if (str === "" || str.trim() === "") {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>

<style>
.free-delivery .slick-dots {
  bottom: 10px !important;
}

.free-delivery .slick-dots li button:before {
  font-size: 9px;
}

.free-delivery .slick-dots .slick-dots li.slick-active button:before {
  opacity: 0.75 !important;
  color: rgba(var(--theme-primary)) !important;
}

.free-delivery .slick-dots li button:hover:before,
.free-delivery .slick-dots li button:focus:before {
  opacity: 0.25;
}
</style>
